<template>
  <router-link
    :to="`/salon/${id}`"
    class="bg-white rounded-lg shadow-md flex flex-col hover:shadow-lg transition-shadow"
  >
    <div class="relative rounded-t-lg overflow-hidden">
      <img :src="logo" :alt="`Image de ${nom}`" class="w-full h-48 object-cover" />
      <div class="absolute bottom-3 right-3 bg-gray-900 bg-opacity-90 text-white text-xs rounded-md px-2 py-1 flex items-center space-x-1">
        <i class="far fa-clock"></i>
        <span>{{ horaire }}</span>
      </div>
    </div>
    <div class="p-4 flex flex-col flex-grow">
      <div class="flex justify-between items-center mb-1">
        <h3 class="font-semibold text-sm text-gray-900">{{ nom }}</h3>
        <div class="flex items-center text-xs text-indigo-700 font-semibold bg-indigo-100 rounded px-2 py-0.5">
          <i class="fas fa-paper-plane mr-1"></i>
          {{ distance }} km
        </div>
      </div>
    </div>
    <div class="bg-[#18b7bd] text-white text-sm font-semibold py-3 rounded-b-lg text-center hover:bg-indigo-700 transition">
      Voir le salon
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'SalonCard',
  props: {
    id: [String, Number],
    logo: String, // ✅ utilisé comme image source
    nom: String,
    horaire: String,
    distance: String,
    avisCount: {
      type: Number,
      default: 0
    }
  }
}
</script>
